import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

import dataV from '@jiaminghi/data-view';
import * as echarts from 'echarts';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { createSocket } from '@/utils/websocket';
import EventBus from '@/eventBus.ts';
import Storage from 'store';

import * as Model from '@/utils/i3dAction';
import * as MockData from '@/utils/mockData';

Vue.use(ElementUI);
Vue.use(dataV);
Vue.prototype.$bus = EventBus;
Vue.prototype.$echarts = echarts;
Vue.prototype.$Model = Model;
Vue.prototype.$Mock = MockData;
Vue.prototype.$Storage = Storage;

window.$Model = Model;

// 连接 websocket
createSocket();
Vue.config.errorHandler = function (err, vm, info) {
  console.error(err);
  // 阻止错误弹窗
  // ...
};
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

function setRootScale() {
  const designWidth = 3200;
  const designHeight = 900;
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const scaleX = screenWidth / designWidth;
  const scaleY = screenHeight / designHeight;
  const scale = Math.min(scaleX, scaleY);
  document.body.style.transform = `scale(${scale})`;
  // document.body.style.transformOrigin = '0 0';
  document.body.style.transformOrigin = 'left';
}

// 初始化时设置缩放比例
setRootScale();

// 监听窗口尺寸变化，重新设置缩放比例
window.addEventListener('resize', setRootScale);

Vue.filter('FormatNumber', function (nums) {
  const num = Number(nums);
  let result = '';
  // 在这里实现数字格式化逻辑
  if (num >= 10000) {
    var formattedNumber = (num / 10000).toFixed(2) + '万';
    result = formattedNumber;
  } else {
    result = num.toFixed(2).toString();
  }
  return result;
});
